import React, { useState, useEffect } from 'react';
import { Row, Col, Table, Spin, Alert, Tag, Tooltip, Button, Modal } from 'antd';
import moment from 'moment';
import { getHolidayEnquiryList } from '../services/auth/authServices';
import { FaEye } from 'react-icons/fa';
import HolidayBookingDetail from './HolidayBookingDetail';

const HolidayBookingHistory = () => {

    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [enquiryId, setEnquiryId] = useState(null);


    const fetchHolidayData = async () => {

        setLoading(true);
        setError(null);

        try {
            const response = await getHolidayEnquiryList();
            setDataSource(response.data);

        } catch (err) {

            setError(err.message);

        } finally {

            setLoading(false);

        }

    };


    useEffect(() => {
        fetchHolidayData();
    }, []);


    const handleView = (id) => {
        setEnquiryId(id);
        setIsModalVisible(true);

    };



    const columns = [

        {
            title: "Enquiry",
            key: "enquiry_number",
            render: (text, record, index) => index + 1
        },


        {
            title: "Name",
            dataIndex: "name",
            key: "name"
        },

        {
            title: "Email",
            dataIndex: "email",
            key: "email"
        },

        {
            title: "Mobile",
            dataIndex: "mobile_number",
            key: "mobile_number"
        },

        {
            title: "Enquiry Type",
            dataIndex: "enquiry_type",
            key: "enquiry_type",
            render: (type) => (
                <Tag color="blue">{type}</Tag>
            )
        },

        {
            title: "Packages",
            dataIndex: "package",
            key: "package",
            render: (pkg) => pkg?.package_name || "No Package"
        },

        {
            title: "Status",
            dataIndex: "followup_status",
            key: "followup_status",
            render: (status) => (

                <Tag color={
                    status === "PENDING"
                        ? "orange"
                        : status === "COMPLETED"
                            ? "green"
                            : "red"
                }>
                    {status}
                </Tag>

            )
        },

        {
            title: "Enquiry Date",
            dataIndex: "created_at",
            key: "created_at",
            render: (date) => moment(date).format("DD MMM YYYY")
        },
        {
            title: "Action",
            key: "action",

            render: (_, record) => (

                <Tooltip title="View Details">
                    <Button
                        type="primary"
                        icon={<FaEye />}
                        onClick={() => handleView(record.id)}
                    />
                </Tooltip>

            )

        }


    ];



    return (

        <section className="my-booking mb-5">
            <div className="container">
                <Row>
                    <Col md={24}>
                        {loading ?
                            <Spin style={{
                                display: "flex",
                                justifyContent: "center",
                                height: "60vh"
                            }} />
                            :
                            error ?
                                <Alert message={error} type="error" />
                                :
                                <Table
                                    columns={columns}
                                    dataSource={dataSource.map((item, index) => ({
                                        key: index,
                                        ...item
                                    }))}
                                    pagination={{ pageSize: 10 }}
                                />

                        }

                    </Col>

                </Row>

            </div>


            <Modal
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={false}
                width={1000}
                centered
            >
                <HolidayBookingDetail enquiryId={enquiryId} />
            </Modal>

        </section>

    );

};

export default HolidayBookingHistory;
